import { Col, Form, Input, Row, Space } from "antd";
import { messageError, messageInfo } from "../../../helpers";
import { get_api_datospersona } from "../../../actions";
import { TipoDocumentoSelect } from "../../configuraciones/TipoDocumentoSelect";

const clearFieldsSearch = (form) => {
  form.setFieldsValue({
    cliente: {
      nombrecompleto: null,
      cliente: null,
    },
  });
};
export const ClienteRow = () => {
  const form = Form.useFormInstance();
  const tipodocumento = Form.useWatch(["cliente", "tipodocumento"], form);
  const handleSearch = async (nrodocumento, event) => {
    event.preventDefault();
    try {
      await form.validateFields(["cliente", "nrodocumento"]);
      if (!!tipodocumento && !!nrodocumento) {
        const datosPersona = await get_api_datospersona({
          tipodocumento,
          nrodocumento,
        });
        if (datosPersona) {
          form.setFieldsValue({
            cliente: {
              nombrecompleto: datosPersona?.nombrecompleto,
              data: JSON.stringify(datosPersona),
            },
          });
        } else {
          clearFieldsSearch();
          messageInfo("No existe datos con el filtro ingresado");
        }
      } else messageInfo("Seleccione o ingrese el tipo y número de documento");
    } catch (error) {
      messageError(error);
    }
  };
  return (
    <>
      <Row gutter={{ xs: 8, sm: 1, md: 16, lg: 24 }}>
        <Col xs={24} sm={24} md={24} lg={12} xl={10} xxl={10}>
          <Form.Item name={["cliente", "nombrecompleto"]}>
            <Input placeholder="Cliente (Opcional)" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={10}>
          <Form.Item>
            <Space.Compact block>
              <Form.Item name={["cliente", "tipodocumento"]} noStyle>
                <TipoDocumentoSelect placeholder="Tipo documento" allowClear />
              </Form.Item>
              <Form.Item
                name={["cliente", "nrodocumento"]}
                noStyle
                rules={[
                  {
                    min: 8,
                    message:
                      "El número de documento tiene que ser de minimo 8 digitos",
                  },
                ]}
              >
                <Input.Search
                  onSearch={handleSearch}
                  placeholder="Número documento (Opcional)"
                  enterButton
                  minLength={8}
                  allowClear
                />
              </Form.Item>
            </Space.Compact>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
